export const PAGES = {
  verifyMfa: "/verify-mfa",
  recoverCode: "/recover-code",
  dashboard: "/dashboard",
  login: "/",
  signIn: "/admin/complete-profile/:id/:email",
  setup2fa: "/setup-2fa",
  accountSettings: "/account-settings",
  kybCompliance: "/kyb-compliance",
  kybComplianceUpdateInformation: "/kyb-compliance/update-information",
  otcRequests: "/otc-requests",
  transactions: "/transactions",
  transactionsV2: "/transactions",
  legacyAccounts: "/accounts",
};
